// src/app/builder/builder.store.ts
import { Injectable, signal, inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { WelodgeService } from '../../services/welodge.service';
import { WlConsensiBeService } from '../../services/wl-consensi-be.service';
import { TokenService } from '../../services/token.service';
import { ConfigService } from '../../services/config.service';

type CallState = 'idle' | 'loading' | 'success' | 'error';

@Injectable({ providedIn: 'root' })
export class BuilderStore {
  // --- deps ---
  private http = inject(HttpClient);
  private welodge = inject(WelodgeService);
  private wlcon = inject(WlConsensiBeService);
  private tokenSvc = inject(TokenService);
  private cfg = inject(ConfigService);
  private fb = inject(FormBuilder);
  private router = inject(Router);

  // --- state (signals) ---
  instance = signal<string>('');
  templateId = signal<number>(-1);
  modelName = signal<string>('');
  modelCode = signal<string>('');
  initialMetadata = signal<any>({});
  businessGroups = signal<any[]>([]);
  pdfModels = signal<any[]>([]);
  filteredPdfModels = signal<any[]>([]);
  form = signal<FormGroup | null>(null);
  sectionToggles = signal<Record<string, boolean>>({});
  optionTextChunks = signal<Record<string, (string | { tag: string })[]>>({});
  buId = signal<number | null>(null);
  tags = signal<any[]>([]);
  toSign = signal<boolean>(false);
  toSignDigital = signal<boolean>(false);
  areaCode = signal<string>('');
  structureCode = signal<string>('');
  digitalSignUsername = signal<string>('');
  digitalSignPassword = signal<string>('');
  isPasswordPassedAtStart = signal<boolean>(false);
  manualSignUsername = signal<string>('');
  manualSignPassword = signal<string>('');
  digitalSignProvider = signal<string>('');
  graphometricSignProvider = signal<string>('')
  documentType = signal<string>('');
  nosologicalCode = signal<string>('')
  parentId = signal<string>('');
  typeCode = signal<string>('');
  typeName = signal<string>('');
  appCode = signal<string>('');

  bgState = signal<CallState>('idle');
  modelsState = signal<CallState>('idle');
  tagListState = signal<CallState>('idle');
  pdfState = signal<CallState>('idle');


  setToSign(event : boolean)
  {
  this.toSign.set(event)

  }

   setToSignDigital(event : boolean)
  {
  this.toSignDigital.set(event)

  }
}
